import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import SettingsSaveFilesSongItem from './SettingsSaveFilesSongItem'

import { removeDownloadedSong } from 'store/actions'

class SettingsSaveFilesSongList extends Component {
  toggleSelectedSongHandler = (songId) => {
    if (this.props.selectedSongs.has(songId)) this.props.selectedSongs.delete(songId)
    else if (!this.props.downloadedSongs.includes(songId))
      this.props.selectedSongs.add(songId)

    this.props.setSelectedSongsHandler(this.props.selectedSongs)
  }

  // Note: component reused from alarm submenu, so many of the same classes prefixed with 'alarm_...' are reused
  render() {
    return (
      <ul className="alarm_block_list save_files_mod">
        {this.props.allSongs.map((song) => (
          <SettingsSaveFilesSongItem
            key={song.songId}
            {...song}
            selectSongHandler={() => this.toggleSelectedSongHandler(song.songId)}
            selected={this.props.selectedSongs.has(song.songId)}
            downloaded={this.props.downloadedSongs.includes(song.songId)}
            deleteDownloadHandler={() => this.props.removeDownloadedSong(song.songId)}
          />
        ))}
      </ul>
    )
  }
}

const mapStateToProps = ({ player: { allSongs }, download: { downloadedSongs } }) => ({
  allSongs,
  downloadedSongs,
})

const willMapDispatchToProps = { removeDownloadedSong }

export default connect(mapStateToProps, willMapDispatchToProps)(SettingsSaveFilesSongList)

SettingsSaveFilesSongList.propTypes = {
  allSongs: PropTypes.array.isRequired,
  setSelectedSongsHandler: PropTypes.func.isRequired,
  selectedSongs: PropTypes.object.isRequired,
  downloadedSongs: PropTypes.array.isRequired,
}
